export * from "./ManagementSecondSpecCard";
